import { api, app } from 'xadmin'

function getUrlParms(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let href = window.location.href.substr(window.location.href.indexOf('?'))
  let r = href.substr(1).match(reg);
  if (r != null)
    return unescape(r[2]);
  return null;
}

export default function freePasswordLogin(store) {
  const token = getUrlParms('token')

  const { host } = window.location

  // 免密登录标识 目的 不重复调用接口
  const portalLogin = sessionStorage.getItem(`portal_login`)

  const portalToken = sessionStorage.getItem(`${host}_portal_token`)

  return new Promise((resolve, reject) => {
    // 如果url里存在token就不再调用免密登录接口
    if (token) {
      reject(false)
      sessionStorage.removeItem('portal_login')
      return
    }

    if (portalToken && !portalLogin) {
      return api({ name: 'core/auth/' })
        .fetch('project/token', {
          method: 'POST',
          body: JSON.stringify({ portalToken })
        })
        .then(data => {
          if (data?.status === 200) {
            resolve(data)
            sessionStorage.setItem('portal_login', true)
          } else {
            reject(data)
            sessionStorage.removeItem('portal_login')
          }
        })
        .catch(e => {
          reject(e)
          sessionStorage.removeItem('portal_login')
        })
    } else {
      reject(false)
      sessionStorage.removeItem('portal_login')
    }
  })

}